import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=06ede6ec&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ede6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ede6ec')) {
      api.createRecord('06ede6ec', component.options)
    } else {
      api.reload('06ede6ec', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=06ede6ec&scoped=true&", function () {
      api.rerender('06ede6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wN9idVRvSwg0/JS/comp/Voucher-Unit.vue"
export default component.exports